<template>
    <div>
        <!-- CONTENT -->
        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Options</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <b-field>
                    <b-switch v-model="component.content.attributes.required">Require Question to be Answered to Continue</b-switch>
                </b-field>
            </div>
        </b-collapse>

        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Reflection Instruction</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <content-blocks :blocks="component.content.content.question"/>
            </div>

        </b-collapse>

        <!-- answers -->
        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Answer Options</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content pr-5 ml-5 pl-2">
                <i class="far fa-fw fa-info-circle mr-2"></i>A <strong>Reflection/Open Question Checkpoint</strong> allows participant to record a open response with no correct or incorrect answers.<br>
                <i class="far fa-fw mr-2"></i>If they fail to provide any response it is considered 'incorrect'.
            </div>

        </b-collapse>

        <!-- response -->
        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Question Response</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <h6>Correct</h6>
            <div class="content">
                <content-blocks :blocks="component.content.content.correct"/>
            </div>

            <h6>Incorrect</h6>
            <div class="content">
                <content-blocks :blocks="component.content.content.incorrect"/>
            </div>

        </b-collapse>
    </div>
</template>

<script>
    import ContentBlocks from "../ContentBlocks.vue";

    export default {
        components: {ContentBlocks},
        props: ['component']
    };
</script>

<style lang="scss" scoped>
    .collapse-header {
        border-bottom: 2px solid #e7e7e7;
        padding-bottom: 0;
        margin-bottom: 20px;

        i {
            padding: 0 10px;
        }
    }
</style>
